let resumeTimeout = null;
let clickHandler = null;
let visibilityHandler = null;

function clearPendingResume() {
  if (resumeTimeout) {
    clearTimeout(resumeTimeout);
    resumeTimeout = null;
  }
  if (clickHandler) {
    document.removeEventListener('click', clickHandler);
    clickHandler = null;
  }
  if (visibilityHandler) {
    document.removeEventListener('visibilitychange', visibilityHandler);
    visibilityHandler = null;
  }
}

export function scheduleResume(task, dispatch) {
  clearPendingResume();

  const resume = () => {
    console.log('[pauseManager] resuming task', task?.id);
    clearPendingResume();
    dispatch('task/startTracking', { task, manual: true }, { root: true });
  };

  clickHandler = () => resume();

  visibilityHandler = () => {
    if (document.visibilityState === 'visible') resume();
  };

  setTimeout(() => {
    if (!clickHandler) {
      console.log('[pauseManager] scheduleResume was cancelled before listeners were added');
      return;
    }
    console.log('[pauseManager] listening for click/visibility to resume task', task?.id);
    document.addEventListener('click', clickHandler, { once: true });
    document.addEventListener('visibilitychange', visibilityHandler);
  }, 0);
}

export function scheduleResumeAfterMinutes(minutes, task, dispatch) {
  clearPendingResume();

  resumeTimeout = setTimeout(() => {
    clearPendingResume();
    dispatch('task/startTracking', { task, manual: true }, { root: true });
  }, minutes * 60 * 1000);
}

export function cancelScheduledResume() {
  clearPendingResume();
}
